module.exports = __webpack_public_path__ + "static/img/5.a3a3a6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/eng/5.png
// module id = ov+j
// module chunks = 0